module.exports = __webpack_public_path__ + "img/omni.cf53d168.svg";